export const POINT = 100;
export const keywordRate = {
    rate: 15,
    items: 2
}
export const technicalSeoRate = {
  rate: 20,
  items: 3
}
export const mainContentRate = {
  rate: 25,
  items: 7
}
export const metaTagRate = {
  rate: 15,
  items: 4
}
export const linkRecommendRate = {
  rate: 10,
  items: 2
}
export const faqsRate = {
  rate: 10,
  items: 3
}
export const urlsRate = {
  rate: 5,
  items: 3
}

export const priorityRate = {
  high: 1,
  medium: 0.75,
  low: 0.5
};
export const statusRate = {
  good: 1,
  bad: 0
};
export const KEYWORD_POINTS =  (keywordRate.rate / keywordRate.items);
export const TECHNICAL_SEO_POINTS =  (technicalSeoRate.rate / technicalSeoRate.items);
export const MAIN_CONTENT_POINTS =  (mainContentRate.rate / mainContentRate.items);
export const META_TAG_POINTS =  (metaTagRate.rate / metaTagRate.items);
export const LINK_RECOMMEND_POINTS =  (linkRecommendRate.rate / linkRecommendRate.items);
export const FAQS_POINTS =  (faqsRate .rate / faqsRate .items);
export const URLS_POINTS =  (urlsRate.rate / urlsRate.items);



export const SINGLE_H1_ID = 'singleH1';
export const META_DESCRIPTION_LENGTH_ID = 'metaDescriptionLength';
export const URL_LENGTH_ID = 'urlLength';
export const INTERNAL_LINKS_ID = 'internalLinks';
export const EXTERNAL_LINKS_ID = 'externalLinks';
export const TITLE_WIDTH_ID = 'titleWidth';
export const TEXT_IMAGES_ID = 'textImages';
export const SCHEMA_ID = 'schema';
export const SINGLE_TITLE_ID = 'singleTitle';

export const technicalSEOCategory = [
  SINGLE_H1_ID,
  META_DESCRIPTION_LENGTH_ID,
  URL_LENGTH_ID,
  INTERNAL_LINKS_ID,
  EXTERNAL_LINKS_ID,
  TITLE_WIDTH_ID,
  TEXT_IMAGES_ID,
  SCHEMA_ID,
  SINGLE_TITLE_ID
];

export const INTRODUCTION_KEYWORD_ID = 'introductionKeyword';
export const SENTENCE_BEGINNINGS_ID = 'sentenceBeginnings';
export const TEXT_SENTENCE_LENGTH_ID = 'textSentenceLength';
export const TEXT_LENGTH_ID = 'textLength';
export const FAQs_ASSESSMENT_ID = 'faqs';
export const FAQs_STRUCTURE_DATA_ID = 'faqsStructuredData';
export const KEYWORD_FAQs_ASSESSMENT_ID = 'keywordFaqs';
export const TITLE_KEYWORD_ID = 'titleKeyword';
export const KEYPHRASE_LENGTH_ID = 'keyphraseLength';
export const TEXT_TRANSITION_WORDS_ID = 'textTransitionWords';
export const KEYPHRASE_DENSITY_ID = 'keyphraseDensity';
export const SLUG_KEYWORD_ID = 'slugKeyword';
export const CHARACTERS_URL = 'charactersUrl';
export const KEYPHRASE_ID = 'keyphrase';
export const TEXT_PARAGRAPH_TOO_LONG_ID = 'textParagraphTooLong';
export const SUBHEADINGS_KEYWORD_ID = 'subheadingsKeyword';
export const IMAGES_ID = 'images';
export const NUMBER_TITLE_ID = 'numberTitle';
export const META_DESCRIPTION_KEYWORD_ID = 'metaDescriptionKeyword';
export const RELATED_KEYWORDS_ID = 'relatedKeywords';
export const RELATED_KEYWORDS_DENSITY_ID = 'relatedKeywordsDensity';
export const MEDIA_ID = 'media';

export const contentSEOCategory = [
  INTRODUCTION_KEYWORD_ID,
  FAQs_ASSESSMENT_ID,
  SENTENCE_BEGINNINGS_ID,
  TEXT_SENTENCE_LENGTH_ID,
  TEXT_LENGTH_ID,
  TITLE_KEYWORD_ID,
  KEYPHRASE_LENGTH_ID,
  TEXT_TRANSITION_WORDS_ID,
  KEYPHRASE_DENSITY_ID,
  SLUG_KEYWORD_ID,
  KEYPHRASE_ID,
  TEXT_PARAGRAPH_TOO_LONG_ID,
  SUBHEADINGS_KEYWORD_ID,
  IMAGES_ID,
  NUMBER_TITLE_ID,
  META_DESCRIPTION_KEYWORD_ID,
  KEYWORD_FAQs_ASSESSMENT_ID,
  RELATED_KEYWORDS_ID,
  RELATED_KEYWORDS_DENSITY_ID,
  MEDIA_ID,
  CHARACTERS_URL,
  FAQs_STRUCTURE_DATA_ID,
];


export const idPointsMap = {
  // keyword (15pts / 2 items = 7.5)
  [KEYPHRASE_ID]: KEYWORD_POINTS,
  [RELATED_KEYWORDS_ID]: KEYWORD_POINTS,
  // technicalSeo (20pts / 3 items ≈ 6.67)
  [SINGLE_H1_ID]: TECHNICAL_SEO_POINTS,
  [SINGLE_TITLE_ID]: TECHNICAL_SEO_POINTS,
  [SCHEMA_ID]: TECHNICAL_SEO_POINTS,
  // mainContent (25pts / 7 items ≈ 3.57)
  [KEYPHRASE_DENSITY_ID]: MAIN_CONTENT_POINTS,
  [TEXT_PARAGRAPH_TOO_LONG_ID]: MAIN_CONTENT_POINTS,
  [RELATED_KEYWORDS_DENSITY_ID]: MAIN_CONTENT_POINTS,
  [TEXT_SENTENCE_LENGTH_ID]: MAIN_CONTENT_POINTS,
  [INTRODUCTION_KEYWORD_ID]: MAIN_CONTENT_POINTS,
  [SUBHEADINGS_KEYWORD_ID]: MAIN_CONTENT_POINTS,
  [TEXT_LENGTH_ID]: MAIN_CONTENT_POINTS,
  // metaTags (15pts / 4 items = 3.75)
  [TITLE_WIDTH_ID]: META_TAG_POINTS,
  [META_DESCRIPTION_LENGTH_ID]: META_TAG_POINTS,
  [META_DESCRIPTION_KEYWORD_ID]: META_TAG_POINTS,
  [TITLE_KEYWORD_ID]: META_TAG_POINTS,
  // linkRecommend (10pts / 2 items = 5)
  [INTERNAL_LINKS_ID]: LINK_RECOMMEND_POINTS,
  [EXTERNAL_LINKS_ID]: LINK_RECOMMEND_POINTS,
  // faqs (10pts / 3 items ≈ 3.33)
  [FAQs_ASSESSMENT_ID]: FAQS_POINTS,
  [KEYWORD_FAQs_ASSESSMENT_ID]: FAQS_POINTS,
  [FAQs_STRUCTURE_DATA_ID]: FAQS_POINTS,
  // urls (5pts / 3 items ≈ 1.67)
  [URL_LENGTH_ID]: URLS_POINTS,
  [SLUG_KEYWORD_ID]: URLS_POINTS,
  [CHARACTERS_URL]: URLS_POINTS,
};
